import React from 'react';

type AuthMethod = 'telegram' | 'email' | '';

interface VerifyOtpProps {
  method: AuthMethod;
  secret: string;
  isLoading: boolean;
  errorOnVerify: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onBack: () => void;
}

const OtpVerify: React.FC<VerifyOtpProps> = ({ method, secret, isLoading, errorOnVerify, onChange, onSubmit, onBack }) => (
  <div className="nexus-content">
    <h2>Verify Code</h2>
    <p className="nexus-subtitle">Sent to {method === 'email' ? 'your email' : 'telegram'}</p>
    <div className="nexus-input-group">
      <label className="nexus-label">6-Digit Code</label>
      <input
        type="text"
        className="nexus-input"
        maxLength={6}
        placeholder="000000"
        value={secret}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ''))}
      />
    </div>
    <div className="nexus-error-container">
      {errorOnVerify && <span className="nexus-error-message">{errorOnVerify}</span>}
    </div>
    <button className="nexus-btn" disabled={isLoading} onClick={onSubmit}>
      {isLoading ? 'Verifying...' : 'Verify Now'}
    </button>
    <button className="nexus-btn-back" onClick={onBack}>← Resend or Change Method</button>
  </div>
);

export default OtpVerify;
